import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Target, CalendarCheck, ListChecks, CalendarRange, ClipboardList, TrendingUp } from "lucide-react";
import Programmes from "@/components/Programmes";
import Rolls from "@/components/Rolls";
import { LiveBookings, Rules } from "@/components/Bookings";
import { AdminBooking } from "@/components/OpsExtras";
import { TermsCard } from "@/components/Settings";
import { PickupTab } from "@/components/Families";
import ActivityHistoryTab from "@/components/ActivityHistoryTab";
import { PageHeader, SubTabs, asTabs } from "@/components/PageChrome";
import { useAuth } from "@/auth/AuthContext";
import { isFloorStaff } from "@/lib/roles";

// Day-to-day jobs first (the roll, the pick-up lists, who's booked), term set-up after
export const TABS = [["rolls", "Rolls", ListChecks], ["pickup", "Pick-up lists", ClipboardList], ["bookings", "Bookings", CalendarCheck], ["programmes", "Programmes", Target], ["terms", "Term dates", CalendarRange], ["history", "Activity History", TrendingUp]];

export default function Activities({ api, settings, year, reloadSettings, initialTab }) {
  const { user } = useAuth();
  // Activity History is per-activity income and Term dates is a settings editor: management's, not floor staff's
  const tabs = isFloorStaff(user) ? TABS.filter(([k]) => k !== "history" && k !== "terms") : TABS;
  const [tab, setTab] = useState(initialTab && tabs.some(([k]) => k === initialTab) ? initialTab : "rolls");
  const [schools, setSchools] = useState([]);
  const loadSchools = useCallback(() => axios.get(`${api}/schools`).then((r) => setSchools(r.data)).catch(() => {}), [api]);
  useEffect(() => { if (tab === "pickup") loadSchools(); }, [tab, loadSchools]);
  return (
    <div className="space-y-6" data-testid="activities">
      <PageHeader eyebrow="Activities" title="Programmes & bookings" testId="activities-header">
        <SubTabs tabs={asTabs(tabs)} value={tab} onChange={setTab} testId="activities-subtabs" itemTestId={(k) => `activities-subtab-${k}`} />
      </PageHeader>
      {tab === "programmes" && <Programmes api={api} />}
      {tab === "bookings" && <div className="space-y-6" data-testid="activities-bookings"><LiveBookings api={api} /><AdminBooking api={api} />{!isFloorStaff(user) && <Rules api={api} />}</div>}
      {tab === "rolls" && <Rolls api={api} />}
      {tab === "history" && <ActivityHistoryTab api={api} />}
      {tab === "terms" && <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-testid="activities-terms"><TermsCard api={api} settings={settings} year={year} onSaved={reloadSettings} /></div>}
      {tab === "pickup" && <PickupTab api={api} schools={schools} onSchoolsChanged={loadSchools} />}
    </div>
  );
}
